import React, { RefObject, useMemo, useState } from 'react'
import { ReactSVG } from 'react-svg';
import mergeIcon from '../../assets/images/icon/toolbar/merge.svg';
import { ListVars, MergeFieldsItems } from '../../modules/editor';
import { useCloseTrigger } from './meta';
import './styles.scss';

interface IMergeButton {
  mode?: 'inputright';
  accountPlan?: any;
  listVars?: ListVars;
  systemFields?: MergeFieldsItems;
  onSelect?: (merge: string) => void;
  onClose?: () => void;
}

const MergeButton = ({ mode, listVars, systemFields, onSelect, onClose }: IMergeButton) => {
  const _mode = mode || '';

  const [open, setOpen] = useState(false);
  const { ref } = useCloseTrigger(open, () => close());

  const toggle = () => setOpen(prev => !prev);

  const close = () => {
    setOpen(false);
    onClose && onClose();
  }

  const select = (value: string) => {
    const syntax = `$%${value}%$`;
    onSelect&& onSelect(syntax);
    close();
  }

  const groups = useMemo(() => {
		const _systemFields = systemFields?.map(({ label, substitution }) => ({ label, value: substitution }));

		// 사용자정의 필드는 사용성 문제로 추후 추가할 예정
		const _listVars = null;
		// let _listVars = listVars
    //   ?.filter(({ substitution, value }) => !substitution?.includes('$') && !value?.includes('$'))
    //   .map(({ label, substitution, value }) => ({ label, value: substitution || value }));

    // const isStandard = accountPlan != null && accountPlan >= 2;
    // if (!isStandard) _listVars = [];

		return [_systemFields, _listVars];
	}, [listVars, systemFields]);

  return (
    <button id="MergeButton"
      className={_mode + (open ? ' active' : '')}
      onClick={toggle}
    >
      <ReactSVG src={mergeIcon} />
      {open && (
        <div ref={ref as RefObject<HTMLDivElement>} className="dropdown" onClick={(e) => e.stopPropagation()} tabIndex={1}>
          <ul className="list">
            {groups?.map((vars, i) => {
              if (vars == null || vars?.length === 0) return <></>;
              const groupname = i === 0 ? '기본 필드' : '사용자 정의 필드';
              return (
                <>
                  <div key={groupname} className="group">{groupname}</div>
                  {vars.map(({ label, value }) => {
                    return <li key={value} className="var" onClick={() => select(value)}><span className="label">{label}</span>{' '}<span className="value">{value}</span></li>;
                  })}
                </>
              )
            })}
          </ul>
        </div>
      )}
    </button>
  )
}

export default MergeButton;
